import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to top on route change, EXCEPT when only the language prefix
 * changes (e.g. /pe/privacy <-> /en/privacy).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const prev = window.__lastPath || "";
    window.__lastPath = pathname;

    const stripLang = (p) => p.replace(/^\/(pe|en)(?=\/|$)/, "") || "/";
    if (stripLang(prev) === stripLang(pathname) && prev !== pathname) {
      // language switch only – keep current scroll position
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
